/**
 * Mobile sticky buy box (TROOP-563): fixed bar when the original add-to-cart
 * leaves the viewport. No Shopify Verify / A-B test runtime.
 */
(() => {
  const BAR_ID = 'mobile-sticky-buybox';
  const BODY_CLASS = 'has-mobile-sticky-buybox';
  const VARIANT_FOCUS_CLASS = 'mobile-sticky-buybox--variant-focus';
  const MQ = '(max-width: 749px)';
  const TRUST_BADGE_GAP_PX = 8;
  const TRUST_LIFT_MARK = 'data-mobile-sticky-trust-lift';

  /**
   * Trusted Shops setzt `bottom` per Inline-Style auf fixierte Kinder — normales CSS greift nicht.
   * Nur auf der PDP mit Sticky-Leiste: bei sichtbarer Leiste `bottom` per setProperty(..., 'important') setzen.
   */
  const syncTrustBadgeLift = (pxFromBottom) => {
    document.querySelectorAll(`[${TRUST_LIFT_MARK}]`).forEach((el) => {
      el.style.removeProperty('bottom');
      el.style.removeProperty('transform');
      el.removeAttribute(TRUST_LIFT_MARK);
    });

    const liftPx = Math.round(Number(pxFromBottom) || 0);
    if (liftPx <= 0) return;

    const val = `${liftPx}px`;

    document.querySelectorAll('div[id^="trustbadge-container"]').forEach((root) => {
      const fixedEls = [...root.querySelectorAll('*')].filter((el) => {
        if (getComputedStyle(el).position !== 'fixed') return false;
        const r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      });

      if (fixedEls.length > 0) {
        fixedEls.forEach((el) => {
          el.setAttribute(TRUST_LIFT_MARK, '');
          el.style.setProperty('bottom', val, 'important');
        });
        return;
      }

      if (getComputedStyle(root).position === 'fixed') {
        root.setAttribute(TRUST_LIFT_MARK, '');
        root.style.setProperty('bottom', val, 'important');
        return;
      }

      root.setAttribute(TRUST_LIFT_MARK, '');
      root.style.setProperty('transform', `translate3d(0, -${liftPx}px, 0)`, 'important');
    });
  };

  const getProductInfo = () => document.querySelector('#MainContent product-info[id^="MainProduct-"][data-mobile-sticky-buybox]');

  const getInventoryShort = (el) => {
    if (!el) return '';
    const raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!raw) return '';
    const first = raw.split(',')[0].trim();
    return first || raw;
  };

  const buildBar = () => {
    let bar = document.getElementById(BAR_ID);
    if (bar) return bar;

    bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.className = 'mobile-sticky-buybox';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `
      <div class="mobile-sticky-buybox__inner">
        <div class="mobile-sticky-buybox__row mobile-sticky-buybox__row--top">
          <div class="mobile-sticky-buybox__title-wrap">
            <p class="mobile-sticky-buybox__title"></p>
            <a href="#" class="mobile-sticky-buybox__variant-link hidden"></a>
          </div>
          <div class="mobile-sticky-buybox__price-col">
            <div class="mobile-sticky-buybox__price"></div>
            <div class="mobile-sticky-buybox__inv"></div>
          </div>
        </div>
        <div class="mobile-sticky-buybox__row mobile-sticky-buybox__row--bottom">
          <div class="mobile-sticky-buybox__qty" data-sticky-qty-wrap hidden>
            <button type="button" class="mobile-sticky-buybox__qty-btn mobile-sticky-buybox__qty-btn--minus" name="minus">−</button>
            <input type="number" class="mobile-sticky-buybox__qty-input" min="1" step="1" value="1" inputmode="numeric" />
            <button type="button" class="mobile-sticky-buybox__qty-btn mobile-sticky-buybox__qty-btn--plus" name="plus">+</button>
          </div>
          <div class="mobile-sticky-buybox__cta"></div>
        </div>
      </div>`;

    document.body.appendChild(bar);
    return bar;
  };

  let activeTeardown = null;

  const setup = () => {
    activeTeardown?.();

    const productInfo = getProductInfo();
    if (!productInfo || !window.matchMedia(MQ).matches) return;

    const sectionId = productInfo.dataset.section;
    if (!sectionId) return;

    const sel = {
      title: () => document.querySelector(`#ProductInfo-${sectionId} .product__title h1`),
      priceWrap: () => document.getElementById(`price-${sectionId}`),
      inventory: () => document.getElementById(`Inventory-${sectionId}`),
      qtyInput: () => document.getElementById(`Quantity-${sectionId}`),
      qtyMinus: () => document.querySelector(`#ProductInfo-${sectionId} quantity-input.quantity button[name="minus"]`),
      qtyPlus: () => document.querySelector(`#ProductInfo-${sectionId} quantity-input.quantity button[name="plus"]`),
      submit: () => document.getElementById(`ProductSubmitButton-${sectionId}`),
      form: () => document.getElementById(`product-form-${sectionId}`),
      variantSelects: () => document.getElementById(`variant-selects-${sectionId}`),
    };

    const submitBtn = sel.submit();
    if (!submitBtn) return;

    const bar = buildBar();
    const ac = new AbortController();
    const { signal } = ac;

    const titleEl = bar.querySelector('.mobile-sticky-buybox__title');
    const priceEl = bar.querySelector('.mobile-sticky-buybox__price');
    const invEl = bar.querySelector('.mobile-sticky-buybox__inv');
    const ctaEl = bar.querySelector('.mobile-sticky-buybox__cta');
    const variantLink = bar.querySelector('.mobile-sticky-buybox__variant-link');
    const qtyWrap = bar.querySelector('[data-sticky-qty-wrap]');
    const stickyMinus = bar.querySelector('.mobile-sticky-buybox__qty-btn--minus');
    const stickyPlus = bar.querySelector('.mobile-sticky-buybox__qty-btn--plus');
    const stickyInput = bar.querySelector('.mobile-sticky-buybox__qty-input');

    const variantLabel = productInfo.dataset.mobileStickyVariantLabel || '';
    if (variantLabel) variantLink.textContent = variantLabel;

    if (productInfo.dataset.mobileStickyQtyDecrease) stickyMinus.setAttribute('aria-label', productInfo.dataset.mobileStickyQtyDecrease);
    if (productInfo.dataset.mobileStickyQtyIncrease) stickyPlus.setAttribute('aria-label', productInfo.dataset.mobileStickyQtyIncrease);
    if (productInfo.dataset.mobileStickyQtyInput) stickyInput.setAttribute('aria-label', productInfo.dataset.mobileStickyQtyInput);

    const syncStatic = () => {
      const t = sel.title();
      if (t) titleEl.textContent = (t.textContent || '').trim();

      const pw = sel.priceWrap();
      if (pw) {
        const clone = pw.cloneNode(true);
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
        priceEl.innerHTML = '';
        priceEl.appendChild(clone);
      } else {
        priceEl.innerHTML = '';
      }

      const inv = sel.inventory();
      invEl.innerHTML = '';
      if (inv && !inv.classList.contains('visibility-hidden')) {
        const icon = inv.querySelector('.svg-wrapper');
        if (icon) invEl.appendChild(icon.cloneNode(true));
        const span = document.createElement('span');
        span.textContent = getInventoryShort(inv);
        invEl.appendChild(span);
      }

      const vs = sel.variantSelects();
      if (vs && variantLabel) {
        variantLink.classList.remove('hidden');
        variantLink.setAttribute('href', '#');
      } else {
        variantLink.classList.add('hidden');
      }
    };

    const wireCta = () => {
      ctaEl.innerHTML = '';
      const orig = sel.submit();
      if (!orig) return;
      const clone = orig.cloneNode(true);
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
      clone.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          const o = sel.submit();
          if (o) o.click();
        },
        { signal }
      );
      ctaEl.appendChild(clone);
    };

    const setOriginalQty = (val) => {
      const o = sel.qtyInput();
      if (!o) return;
      o.value = val;
      o.dispatchEvent(new Event('input', { bubbles: true }));
      o.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const syncQtyFromOriginal = () => {
      const o = sel.qtyInput();
      if (!o) {
        qtyWrap.hidden = true;
        return;
      }
      qtyWrap.hidden = false;
      stickyInput.value = String(o.value || '1');
    };

    const scrollToVariants = () => {
      const vs = sel.variantSelects();
      if (!vs) return;
      const stickyH = bar.offsetHeight;
      const top = vs.getBoundingClientRect().top + window.scrollY;
      const offset = 16;
      const y = Math.max(0, top - stickyH - offset);
      window.scrollTo({ top: y, behavior: 'smooth' });
      vs.classList.add(VARIANT_FOCUS_CLASS);
      window.setTimeout(() => vs.classList.remove(VARIANT_FOCUS_CLASS), 900);
    };

    variantLink.addEventListener(
      'click',
      (e) => {
        e.preventDefault();
        scrollToVariants();
      },
      { signal }
    );

    stickyMinus.addEventListener(
      'click',
      () => {
        const b = sel.qtyMinus();
        if (b) b.click();
      },
      { signal }
    );

    stickyPlus.addEventListener(
      'click',
      () => {
        const b = sel.qtyPlus();
        if (b) b.click();
      },
      { signal }
    );

    stickyInput.addEventListener(
      'change',
      () => {
        let v = parseInt(stickyInput.value, 10);
        if (!v || v < 1) v = 1;
        stickyInput.value = String(v);
        setOriginalQty(String(v));
      },
      { signal }
    );

    /** CSS-Variable (Cookie-Banner) + Trustbadge per JS mit !important (TS-Inline-Styles). */
    const syncStickyOverlayHeightVar = () => {
      if (!bar.isConnected) return;
      const h = Math.ceil(bar.getBoundingClientRect().height);
      document.body.style.setProperty('--mobile-sticky-buybox-height', `${h}px`);

      if (!window.matchMedia(MQ).matches) {
        syncTrustBadgeLift(0);
        return;
      }
      if (bar.classList.contains('is-visible')) {
        syncTrustBadgeLift(h + TRUST_BADGE_GAP_PX);
      } else {
        syncTrustBadgeLift(0);
      }
    };

    /**
     * Trust-Sync pro Tick coalescen; danach ein zweiter Frame — TS-Badge hat oft erst danach
     * non-zero Bounds / position:fixed, sonst greift nur der Fallback bis zum nächsten Scroll.
     */
    let trustSyncRafId = 0;
    let trustLayoutRetryRafId = 0;

    const scheduleTrustBadgeSync = () => {
      if (!bar.isConnected) return;
      if (trustSyncRafId) return;
      trustSyncRafId = requestAnimationFrame(() => {
        trustSyncRafId = 0;
        if (!bar.isConnected) return;
        syncStickyOverlayHeightVar();
        if (
          bar.classList.contains('is-visible') &&
          window.matchMedia(MQ).matches &&
          document.querySelector('div[id^="trustbadge-container"]')
        ) {
          if (trustLayoutRetryRafId) cancelAnimationFrame(trustLayoutRetryRafId);
          trustLayoutRetryRafId = requestAnimationFrame(() => {
            trustLayoutRetryRafId = 0;
            if (
              !bar.isConnected ||
              !bar.classList.contains('is-visible') ||
              !window.matchMedia(MQ).matches
            ) {
              return;
            }
            syncStickyOverlayHeightVar();
          });
        }
      });
    };

    const updateVisibility = () => {
      if (!bar.isConnected || !window.matchMedia(MQ).matches) return;
      const btn = sel.submit();
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0;
      bar.classList.toggle('is-visible', !inView);
      bar.setAttribute('aria-hidden', inView ? 'true' : 'false');
      scheduleTrustBadgeSync();
    };

    const onScrollOrResize = () => {
      if (!window.matchMedia(MQ).matches) {
        document.body.classList.remove(BODY_CLASS);
        bar.classList.remove('is-visible');
        scheduleTrustBadgeSync();
        return;
      }
      document.body.classList.add(BODY_CLASS);
      updateVisibility();
    };

    const mo = new MutationObserver(() => {
      syncStatic();
      wireCta();
      syncQtyFromOriginal();
      updateVisibility();
    });

    const resizeObserver = new ResizeObserver(() => {
      scheduleTrustBadgeSync();
    });
    resizeObserver.observe(bar);

    /**
     * TS blendet den Badge oft per style/class ein — ohne childList am body.
     * Subtree-Observer auf jedem trustbadge-container; eigene Lift-Markierung ignorieren (keine Schleife).
     */
    const trustBadgeMutationShouldSync = (records) => {
      for (const r of records) {
        if (r.type === 'childList') {
          if (r.addedNodes.length || r.removedNodes.length) return true;
          continue;
        }
        if (r.type === 'attributes' && r.target.nodeType === Node.ELEMENT_NODE) {
          const el = /** @type {Element} */ (r.target);
          if (el.hasAttribute(TRUST_LIFT_MARK) || el.closest(`[${TRUST_LIFT_MARK}]`)) continue;
          return true;
        }
      }
      return false;
    };

    const trustSubtreeObservers = [];
    const trustRootResizeObservers = [];
    const trustRootIntersectionObservers = [];
    const trustSubtreeRoots = new Set();

    const attachTrustBadgeSubtreeObservers = () => {
      document.querySelectorAll('div[id^="trustbadge-container"]').forEach((root) => {
        if (trustSubtreeRoots.has(root)) return;
        trustSubtreeRoots.add(root);
        const subMo = new MutationObserver((records) => {
          if (!trustBadgeMutationShouldSync(records)) return;
          scheduleTrustBadgeSync();
        });
        subMo.observe(root, { childList: true, subtree: true, attributes: true });
        trustSubtreeObservers.push(subMo);

        const trustRo = new ResizeObserver(() => scheduleTrustBadgeSync());
        trustRo.observe(root);
        trustRootResizeObservers.push(trustRo);

        const trustIo = new IntersectionObserver(() => scheduleTrustBadgeSync(), {
          root: null,
          threshold: [0, 0.01, 0.1, 1],
        });
        trustIo.observe(root);
        trustRootIntersectionObservers.push(trustIo);
      });
    };

    let trustMoRaf = 0;
    const trustMo = new MutationObserver(() => {
      if (!document.querySelector('div[id^="trustbadge-container"]')) return;
      if (trustMoRaf) return;
      trustMoRaf = requestAnimationFrame(() => {
        trustMoRaf = 0;
        if (!bar.isConnected) return;
        attachTrustBadgeSubtreeObservers();
        scheduleTrustBadgeSync();
      });
    });
    trustMo.observe(document.body, { childList: true, subtree: true });
    attachTrustBadgeSubtreeObservers();

    const trustRetryIds = [1000, 2500].map((ms) =>
      window.setTimeout(() => {
        if (bar.isConnected) scheduleTrustBadgeSync();
      }, ms)
    );

    [sel.priceWrap(), sel.inventory(), sel.form(), sel.variantSelects()].forEach((el) => {
      if (el) mo.observe(el, { childList: true, subtree: true, attributes: true });
    });

    const qi = sel.qtyInput();
    if (qi) {
      qi.addEventListener('input', syncQtyFromOriginal, { signal });
      qi.addEventListener('change', syncQtyFromOriginal, { signal });
    }

    syncStatic();
    wireCta();
    syncQtyFromOriginal();
    onScrollOrResize();

    window.addEventListener('scroll', onScrollOrResize, { passive: true, signal });
    window.addEventListener('resize', onScrollOrResize, { signal });

    activeTeardown = () => {
      trustRetryIds.forEach((id) => window.clearTimeout(id));
      cancelAnimationFrame(trustSyncRafId);
      cancelAnimationFrame(trustLayoutRetryRafId);
      trustSyncRafId = 0;
      trustLayoutRetryRafId = 0;
      trustSubtreeObservers.forEach((m) => m.disconnect());
      trustSubtreeObservers.length = 0;
      trustRootResizeObservers.forEach((o) => o.disconnect());
      trustRootResizeObservers.length = 0;
      trustRootIntersectionObservers.forEach((o) => o.disconnect());
      trustRootIntersectionObservers.length = 0;
      trustSubtreeRoots.clear();
      trustMo.disconnect();
      syncTrustBadgeLift(0);
      resizeObserver.disconnect();
      mo.disconnect();
      ac.abort();
      document.body.classList.remove(BODY_CLASS);
      document.body.style.removeProperty('--mobile-sticky-buybox-height');
      bar.classList.remove('is-visible');
      bar.remove();
      activeTeardown = null;
    };
  };

  const mql = window.matchMedia(MQ);
  const run = () => setup();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  mql.addEventListener('change', () => {
    if (mql.matches) setup();
    else activeTeardown?.();
  });
})();
